export const environment = {
  production: false,
  recaptcha_site_key: '6LdNmUIkAAAAAHY-GkWmPXmkjbCBdZ0MvJuM4-BY',
  api_url: 'https://paxi-email-proxy-kg34jdjneq-ew.a.run.app/email/send',
};
